import type { FaireProductEntity } from "../../entity_types/product";

export const p_237ugetqod: FaireProductEntity = {
  token: "p_237ugetqod",
  type: "product",
  name: "Dog Days Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/6b4358fdd58c7f7321c7b05924e30f5c9031fae72384b12b47e60219ff487172.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a42925d1f60a64e8cc57f965097cd3aa05162d0d52437e622ddc635dbdd07639.jpeg",
    "https://cdn.faire.com/fastly/5c50aed9a891d29d3d214c105ec1ed7bb824961225fdea315490bc429ffadd81.jpeg",
    "https://cdn.faire.com/fastly/301cb61566ff73d4bb18b51645e4fd167b9e857d7447361c7dfabf6a4cac964a.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:20.140Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
